import React from 'react';
import { ControlsArrowsNextS } from '@lux/icons';
import { NavWrapper } from './styles';
// Navigation is hidden from accessibility tree as it has no user benefit beside stealing tab focus
const Navigation = ({ label, ...rest }) => (React.createElement(NavWrapper, Object.assign({}, rest, { "aria-label": label, tabIndex: -1, "aria-hidden": true }),
    React.createElement(ControlsArrowsNextS, { "aria-label": label })));
export default Navigation;
//# sourceMappingURL=component.js.map